export const DEFAULT_COMPANY_NAME = "GLOBAL METALS";

export const normalizeCompanyName = (name) => {
  const value = String(name || "").trim();
  return value || DEFAULT_COMPANY_NAME;
};

export const getStoredCompanyName = () => {
  return normalizeCompanyName(localStorage.getItem("activeCompanyName"));
};

export const publishCompanyName = (name) => {
  const companyName = normalizeCompanyName(name);
  localStorage.setItem("activeCompanyName", companyName);
  window.dispatchEvent(new CustomEvent("company-name-updated", { detail: { companyName } }));
  return companyName;
};
